import { useEffect } from 'react';

const Toaster = ({ message, type = "success", onClose }) => {

  useEffect(() => {
    const timer = setTimeout(onClose, 3000); // auto close after 3s
    return () => clearTimeout(timer);
  }, [onClose]);

  const typeClasses = {
    success: 'bg-green-500',
    error: 'bg-red-500',
    info: 'bg-blue-500',
  };

  return (
    <div className={`fixed top-5 right-5 z-50 px-4 py-2 rounded text-white shadow-lg ${typeClasses[type]}`}style={{zIndex:"99999999"}}>
      {message}
    </div>
  );
};

export default Toaster;
